import styled from "@emotion/styled";
import { RedirectButton } from "scmp-sdk/components/redirect-button";

import { fontMerriweather, fontRoboto, theme } from "shared/lib/styles";

export const StyledRedirectButton = styled(RedirectButton)`
  block-size: 43.65px;
  min-inline-size: 252px;
  margin-block-start: 40px;

  color: #ffffff;
  font-weight: 400;
  font-size: 16px;
  font-family: ${fontRoboto};
  line-height: 19px;

  border: 1px solid #4585ff;
  border-radius: 3px;

  background: #001246;

  cursor: pointer;

  ${theme.breakpoints.up("tablet")} {
    inline-size: 270px;
  }
`;

export const Container = styled.div`
  position: relative;

  display: flex;
  justify-content: center;
  align-items: center;

  inline-size: calc(100vw - 20px);
  margin: auto;

  background-color: #ffffff;

  outline: none;

  ${theme.breakpoints.up("mobile")} {
    inline-size: 335px;
  }

  ${theme.breakpoints.up("tablet")} {
    inline-size: 440px;
  }
`;

export const ImageContainer = styled.div`
  inline-size: 251px;
  margin-block-start: 22px;

  ${theme.breakpoints.up("tablet")} {
    inline-size: 422px;
    block-size: 256px;
  }

  img {
    display: block;

    inline-size: 100%;
    block-size: 100%;

    object-fit: cover;
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;

  max-inline-size: 300px;
  padding-block: 40px;
  padding-inline: 20px;

  text-align: center;

  ${theme.breakpoints.up("tablet")} {
    max-inline-size: 440px;
    padding: 48px;
  }
`;

export const Title = styled.div`
  margin-block-start: 16px;

  color: #001246;
  font-weight: 900;
  font-size: 20px;
  font-family: ${fontMerriweather};
  line-height: 24px;

  ${theme.breakpoints.up("tablet")} {
    inline-size: 320px;

    font-size: 24px;
    line-height: 29px;
  }
`;

export const Description = styled.div`
  max-inline-size: 250px;
  margin-block-start: 17px;

  color: #000000;
  font-weight: 400;
  font-size: 14px;
  font-family: ${fontRoboto};
  line-height: 20px;
  text-align: center;

  ${theme.breakpoints.up("tablet")} {
    max-inline-size: 100%;

    font-size: 16px;
    line-height: 22px;
  }

  ul {
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;

    list-style: disc inside;
  }
`;

export const DownloadLink = styled.a`
  color: #4585ff;
  text-decoration: underline;

  cursor: pointer;
`;
